/*
 * @Descripttion:  获取手机设备信息
 * @Author: dengyao
 * @Date: 2024-10-17 19:27:04
 * @LastEditors: dengyao
 * @LastEditTime: 2024-10-17 19:43:39
 */
export const usePhoneModel = () => {
  // 判断是否是ios系统或mac系统
  const getPhoneSystemType = () => {
    const ua = navigator.userAgent;
    const browsers = [
      { name: 'Chrome', reg: /Chrome\/(\d+)/ },
      { name: 'Edge', reg: /Edg\/(\d+)/ },
      { name: 'Firefox', reg: /Firefox\/(\d+)/ },
      { name: 'Safari', reg: /Version\/(\d+).+Safari/ },
      { name: 'Opera', reg: /Opera\/(\d+)/ },
      { name: 'IE', reg: /Trident\/7.0.+rv:(\d+)/ } // IE11
    ];

    for (const { name, reg } of browsers) {
      const match = ua.match(reg);
      if (match) return { name, version: match[1] };
    }
    return { name: 'Unknown', version: '0' };
  }
  return {
    getPhoneSystemType,
  }
}
